import { Checkbox } from '@mui/material'
import useStyles from './useStyles'

function TableHeader ({ toggleAll, allChecked, indeterminate }) {
  const classes = useStyles()
  return (
    <thead className={classes.row}>
      <tr>
        <th className={classes.headCheck}>
          <Checkbox />
        </th>
        <th className={classes.status}>Estado</th>
        <th className={classes.headName}>Producto</th>
        <th className={classes.headCode}>Código</th>
        <th className={classes.headType}>Tipo</th>
        <th className={classes.headKebab}></th>
      </tr>
    </thead>
  )
}

export default TableHeader
